import { environment } from '../../environments/environment';
import { InjectionToken } from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
export const APP_CONFIG = new InjectionToken<Object>('APP CONFIG FILE');
export const API_URLS = {
  CAPTCHA: {
    GENERATE: '/generateCaptcha',
    VALIDATE: '/validateCaptcha',
    REFRESH: '/refreshCaptcha',
  },
  BUYERTIN: {
    VALIDATE: '/consumerValidateTin',
  },
  RECEIPT: {
    LOOKUP: '/receiptLookUp',
  },
  SUBMITRECEIPT: {
    SUBMITRECEIPT: '/submitReceipt',
     TRIGGEROTP:'/triggerOTP',
    VALIDATEOTP:'/validateOTP'
  },
};

export class appConfig {
  private static _appConfigService: any;

  public static get appConfigService() {
    return this._appConfigService;
  }
  public static set appConfigService(value) {
    this._appConfigService = value;
  }

  public static updateConstant(configData: any) {
    Constants.BASE_API_URL = configData?.baseApiUrl;
    Constants.GATEWAY_BASE_API_URL = configData?.gatewayBaseApiUrl;
    Constants.CONSUMER_BASE_API_URL = configData?.consumerBaseApiUrl;
    Constants.deploymentWindowCheckTimeInSeconds = configData?.deploymentWindowCheckTimeInSeconds || 10000;
  }
}

export class Constants {
  public static deploymentWindowCheckTimeInSeconds = 10000;
  public static BASE_API_URL = '';
  public static GATEWAY_BASE_API_URL = '';
  public static CONSUMER_BASE_API_URL = '';
}
